import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllDoctors } from '../../api';
import styles from './ListOfDoctors.module.css';

const ListOfDoctors = () => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        setLoading(true);
        const data = await getAllDoctors();
        // Ensure we have an array and filter out any invalid entries
        const validDoctors = Array.isArray(data) ? data.filter(doctor => doctor && typeof doctor === 'object') : [];
        setDoctors(validDoctors);
        setError(null);
      } catch (err) {
        setError('Failed to load doctors');
        console.error('Error fetching doctors:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDoctors();
  }, []);

  const handleBack = () => {
    navigate('/user/dashboard');
  };

  const handleBookAppointment = (doctorId) => {
    navigate(`/user/book-appointment?doctorId=${doctorId}`);
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.loadingContainer}>
            <h2 className={styles.loadingText}>Loading doctors...</h2>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h1 className={styles.title}>List of Doctors</h1>
          <button 
            onClick={handleBack}
            className={styles.backButton}
          >
            Back to Dashboard
          </button>
        </div>

        <div className={styles.mainContent}>
          {error && (
            <div className={styles.errorMessage}>
              {error}
            </div>
          )}

          {doctors.length === 0 ? (
            <div className={styles.emptyState}>
              <h3>No doctors found</h3>
              <p>There are no doctors available at the moment.</p>
            </div>
          ) : (
            <div className={styles.doctorsGrid}>
              {doctors.map((doctor) => (
                <div key={doctor._id} className={styles.doctorCard}>
                  <div className={styles.doctorHeader}>
                    <h3 className={styles.doctorName}>{doctor.name}</h3>
                    <p className={styles.doctorSpecialization}>
                      {doctor.designationDegree}
                    </p>
                    <p className={styles.doctorRegNumber}>
                      Reg. No: {doctor.registrationNumber}
                    </p>
                  </div>
                  
                  <div className={styles.doctorDetails}>
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>Experience:</span>
                      <span className={styles.detailValue}>{doctor.experience} years</span>
                    </div>
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>Phone:</span>
                      <span className={styles.detailValue}>{doctor.phoneNumber}</span>
                    </div>
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>Fees:</span>
                      <span className={`${styles.detailValue} ${styles.feesValue}`}>${doctor.fees}</span>
                    </div>
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>Availability:</span>
                      <span className={doctor.slotAvailability ? styles.availabilityAvailable : styles.availabilityUnavailable}>
                        {doctor.slotAvailability ? 'Available' : 'Not Available'}
                      </span>
                    </div>
                  </div>

                  <button
                    onClick={() => handleBookAppointment(doctor._id)}
                    disabled={!doctor.slotAvailability}
                    className={styles.bookButton}
                  >
                    {doctor.slotAvailability ? 'Book Appointment' : 'Not Available'}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListOfDoctors; 